<mat-card appearance="raised" class="acct-form--container mat-elevation-z12">
  <div class="acct-form--header">
    <h4 class="acct-form--title">{{ sysText[page + '_accountForm_title'] }}</h4>
    <p class="body2 acct-form--subtitle">{{ sysText[page + '_accountForm_subtitle'] }}</p>
  </div>
  <mat-card-content>
    <form
      [formGroup]="acctForm"
      (ngSubmit)="onSubmit()"
      class="acct-form--form">
      @if (options.username.show) {
        <mat-form-field color="accent">
          <mat-label>{{ sysText[page + '_accountForm_username'] }}</mat-label>
          <input
            matInput
            formControlName="username"
            autocomplete="username"/>
            <!-- mat hint for spacing -->
            <mat-hint></mat-hint>
            <mat-error>{{ username.errors?.msError }}</mat-error>
          </mat-form-field>
        }
        @if (options.password.show) {
          <mat-form-field color="accent">
            <mat-label>{{ sysText[page + '_accountForm_password'] }}</mat-label>
            <input
              matInput
              [type]="hidePassword ? 'password' : 'text'"
              formControlName="password"
              [attr.autocomplete]="options.password.autocomplete"/>
              <mat-error>{{ password.errors?.msError }}</mat-error>
              <button type="button" class="button-reset" matSuffix [attr.aria-label]="sysText.showPassword_ariaLabel" [attr.aria-pressed]="!hidePassword" (click)="hidePassword = !hidePassword">
                <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
              </button>
            </mat-form-field>
          }
          @if (options.password.requirements) {
            <app-password-validator
              [reqList]="options.password.requirements"
              [password]="password.value"
              (validationUpdate)="onValidationUpdate($event)"
              >
            </app-password-validator>
          }
          @if (options.phonenumber.show) {
            <div class="acct-form--phone">
              <h6  class="acct-form--title">{{ sysText[page + '_accountForm_phoneTitle'] }}</h6>
              <p class="body2 acct-form--subtitle">{{ sysText[page + '_accountForm_phoneSubtitle'] }}</p>
            </div>
            <mat-form-field color="accent">
              <mat-label>{{ sysText[page + '_accountForm_phonenumber'] }}</mat-label>
              <input
                matInput
                formControlName="phonenumber"
                autocomplete="tel"/>
                <mat-error>{{ phonenumber.errors?.msError }}</mat-error>
              </mat-form-field>
            }
            <!-- submit keeps focus while submitting: showProgress lays the spinner over its label, disabledInteractive keeps it focusable, and onSubmit() is guarded -->
            <button
              type="submit"
              mat-flat-button
              color="accent"
              class="button acct-form--button"
              [disabled]="isSubmitting || !formValid || (buttonDisabled$ | async)"
              disabledInteractive
              [showProgress]="isSubmitting"
              [attr.aria-label]="isSubmitting ? sysText.submitting_ariaLabel : null">
              {{ sysText[page + '_accountForm_button'] }}
              <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
            </button>
          </form>
          <div class="acct-form--link caption">
            <a [routerLink]="['/', options.link.route]">
              {{ sysText[page + '_accountForm_link'] }}
            </a>
          </div>
        </mat-card-content>
      </mat-card>
